module.exports = __webpack_public_path__ + "img/ic_eye.94a7afab.svg";